import {Component, Input, OnInit} from '@angular/core';
import {AppConfigService} from "../../services/app.config.service";

@Component({
  selector: 'lib-user-link',
  templateUrl: './user-link.component.html',
  styleUrls: ['./user-link.component.css']
})
export class UserLinkComponent implements OnInit {
  @Input() user;
  @Input() ngClass;
  isStaff = false;
  constructor(private appConfigService: AppConfigService) { }

  ngOnInit(): void {
    this.isStaff = this.appConfigService.isStaffInterface();
  }

  getUserRole(){
    if (this.user?.roles?.includes('STAFF')) {
      return 'STAFF'
    }
    return 'TLD_MANAGER';
  }
}
